import React from "react";
import "./style.scss";

interface IProps {
  title: string;
  className?: string;
  Icon?: any;
  iconPosition?: "left" | "right" | "center";
  onClick: () => void;
  disabled?: boolean;
  id?: string;
}

const ButtonCustom: React.FC<IProps> = ({
  title,
  className = "",
  Icon,
  iconPosition = "center",
  onClick,
  disabled = false,
  id = "button"
}: IProps) => {
  return (
    <button
      id={id}
      className={`button ${className}`}
      onClick={disabled ? () => {} : () => onClick()}
      disabled={disabled}
    >
      {iconPosition === "left" && <Icon className={"btn-icon"} />}
      {title ? title : <Icon className={"btn-icon"} />}
      {iconPosition === "right" && <Icon className={"btn-icon"} />}
    </button>
  );
};

export default ButtonCustom;
